/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-06-03 09:56:44
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-07-18 09:43:41
 * @FilePath: \vue-hepha-order\src\views\preOrder\queryConfig\queryForm.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

// 配置信息
const AddForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'150px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'preSaleOrder.dealerName',
            key:'customer_erp_code', 
            type:'select',
            required:true,
            width:'420px',
            placeholder:'base.select',
            options:[],
        },
        {
            name:'preSaleOrder.shippingAddress',
            key:'customer_id', 
            type:'select',
            required:true,
            width:'420px',
            placeholder:'base.select',
            options:[],
        },
        {
            name:'preSaleOrder.invoiceAddress',
            key:'customer_invoice_id', 
            type:'select',
            required:true,
            width:'420px',
            placeholder:'base.select',
            options:[],
        },
        {
            name:'preSaleOrder.country',
            key:'country', 
            type:'input',
            disabled:true,
            required:false,
            width:'420px',
            placeholder:'base.input',
        },
        {
            name:'preSaleOrder.paymentType', 
            key:'payment_type',
            type:'select',   
            allowClear:false,
            required:true,
            width:'420px',
            placeholder:'base.select',
            options:[],
        },
        {
            name:'preSaleOrder.winterFinancing',
            key:'winter_flag', 
            type:'select',
            disabled:true,
            required:true,
            width:'420px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {label: 'base.yes', value:'1'}, 
                {label: 'base.no', value:'0'}
            ]
        },
        {
            name:'preSaleOrder.paymentTypeDiscount', 
            key:'payment_type_discount',
            type:'select',   
            allowClear:true,
            required:true,
            disabled:true,
            width:'420px',
            placeholder:'base.select',
            options:[],
        },
        {
            name:'preSaleOrder.payWithDaysDiscountRate', 
            key:'pay_with_days_discount_rate',
            type:'select',   
            allowClear:true,
            required:true,
            disabled:true,
            width:'420px',
            placeholder:'base.select',
            options:[],
        },
        {
            name:'preSaleOrder.paymentDay',
            key:'payment_day',
            type:'select',   
            allowClear:true,
            required:true,
            disabled:true,
            width:'420px',
            placeholder:'base.select',
            options:[],
        },
        {
            name:'preSaleOrder.paymentPeriod',
            key:'payment_due_date', 
            type:'date',
            disabled:true,
            required:true,
            width:'420px',
            placeholder:'base.select',
            showTime:false, 
            show:false,
        },
        {
            name:'preSaleOrder.cashDiscountPeriod',
            key:'pay_with_days_day', 
            type:'select',
            disabled:true,
            required:false,
            width:'420px',
            placeholder:'base.select',
            options:[],
        },
        {
            name:'preSaleOrder.taxRate', 
            key:'tax_rate',
            type:'select',
            width:'420px',
            allowClear:true,
            required:true,
            placeholder:'base.select',
            options:[]
        },
        {
            name:'preSaleOrder.preDiscountRate', 
            key:'pre_discount_rate',
            type:'input',
            width:'420px',
            disabled:true,
        },
    ]
}
AddForm.formField.forEach(item=>{
    AddForm.formData[item.key] = ''
})


export {
    AddForm
}